<template>
  <div>
    <h4>Your Selections</h4>
    <table class="cs-confirmation-table">
      <thead>
      <tr>
        <th>Category</th>
        <th>Selection</th>
        <th>Upgrade Cost</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row in tableData" :key="row.name">
        <td>{{ row.name }}</td>
        <td>
          <selection-sample  @click="showModal(row.feature)" v-if="row.selection" :selections="selections"
                             :selectedID="row.selection"/>
          <div v-else class="cs-select-buttons cs-small-buttons">
            <button class="cs-button" @click="showModal(row.feature)">Select</button>
          </div>
        </td>
        <td>{{ row.cost }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <th span="row">Total Upgrade Cost</th>
        <td></td>
        <td>{{ formatPrice( totalCost ) }}</td>
      </tr>
      </tfoot>
    </table>
  </div>

  <Modal v-model:visible="modalVisible" :title="modalTitle" :width="800">
    <FeatureItem
      :feature="features[currentFeature]"
      :currentChosen="this.chosen[currentFeature]['selection']"
      :selections="selections"
      @chosenSelection="handleSelectionMade($event, features[currentFeature])"
    />
  </Modal>

</template>

<script>
import { Modal } from 'usemodal-vue3';
import SelectionSample from "@/components/SelectionSample";
import FeatureItem from "@/components/FeatureItem";


export default {
  props: [ 'features', 'selections', 'chosen', 'totalCost' ],
  components: {
    FeatureItem,
    SelectionSample,
    Modal
  },
  data() {
    return {
      currentFeature: null,
      modalVisible: false
    };
  },
  computed: {
    tableData() {
      let values = [];
      for ( let key in this.chosen ) {
        const featureName = this.features[ key ][ 'name' ];
        const order = this.features[ key ][ 'order' ];
        let selection = '';
        if ( this.chosen[ key ].selection !== false ) {
          selection = this.chosen[ key ].selection;
        }
        const cost = this.formatPrice( this.chosen[ key ][ 'cost' ] );
        values.push( {
          feature: key,
          name: featureName,
          selection: selection,
          cost: cost,
          order: order,
        } );
      }
      values.sort((a, b) => a.order - b.order);
      return values;
    },
    modalTitle() {
      if (this.currentFeature) {
        return this.features[this.currentFeature].name;
      }
      return '';
    }
  },
  methods: {
    formatPrice( price ) {
      if ( price ) {
        return '$' + price;
      }
      return '';
    },
    showModal( data ) {
      this.modalVisible = true;
      this.currentFeature = data;
    },
    handleSelectionMade( selectionID ) {
      setTimeout( () => {
        this.modalVisible = false;
      }, 500 );
      this.$emit( 'selectionMade', selectionID, this.features[this.currentFeature] );
    }
  },
  emits: [ 'selectionMade' ],
  mounted() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modalVisible) {
        this.modalVisible = false;
      }
    });
  },
  beforeUnmount() {
    window.removeEventListener('keydown', null);
  }

};
</script>


<style lang="scss">
@import 'src/scss/submission-page.scss';
</style>


//todo: not render not completes
